import { inject, Injectable } from '@angular/core';
import { ApiConstantsService } from './api-constants.service';
import {
  StickerMovement,
  StickerMovementListParams,
  StickerMovementStatistics,
  StickerMovementStatisticsParams
} from '~core/models/sticker.models';
import { Observable } from 'rxjs';
import { Pagination } from '~core/models/core.models';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class StickerMovementService {
  private _apiConstantsService = inject(ApiConstantsService);
  private _httpClient = inject(HttpClient);

  readonly apiUrl = this._apiConstantsService.stickerMovementsUrl;

  list(
    params?: StickerMovementListParams
  ): Observable<Pagination<StickerMovement>> {
    return this._httpClient.get<Pagination<StickerMovement>>(this.apiUrl, {
      params: {
        ...params
      }
    });
  }

  read(id: string): Observable<StickerMovement> {
    return this._httpClient.get<StickerMovement>(`${this.apiUrl}/${id}`);
  }

  statistics(
    params?: StickerMovementStatisticsParams
  ): Observable<StickerMovementStatistics> {
    return this._httpClient.get<StickerMovementStatistics>(
      `${this.apiUrl}/statistics`,
      { params }
    );
  }
}
